import { CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { ComponentType } from 'react';
import { Navigate } from 'react-router';
import { useUserApi } from '../../services/api/useUser.api';
import { Role } from '../../types/enums/Role.enum';

interface RoleGuardProps {
  component: ComponentType;
  requiredRoles: Role[];
}

export function RoleGuard({ component: Component, requiredRoles }: RoleGuardProps) {
  const { getUserInfo } = useUserApi();

  const { data: user, isLoading } = useQuery({
    queryKey: ['userInfo'],
    queryFn: getUserInfo,
  });

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  if (!requiredRoles.includes(user?.role.id as Role)) {
    return <Navigate to='/' replace />;
  }

  return <Component />;
}

export default RoleGuard;
